export default "__VITE_ASSET__28_txB5aERK3lAL1e_7BwA__"